import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "../components/auth/AuthLayout";
import AppLayout from "../components/admin/AppLayout";

Vue.use(Router);

const EmptyParentComponent = {
	template: "<router-view></router-view>"
};

export default new Router({
	mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === "true" ? "history" : "hash",
	routes: [
		{
			path: "*",
			redirect: { name: "dashboard" }
		},
		{
			path: "/auth",
			component: AuthLayout,
			children: [
				{
					name: "login",
					path: "login",
					component: () => import("../components/auth/login/Login.vue")
				},
				{
					name: "recover-password",
					path: "recover-password",
					component: () =>
						import("../components/auth/recover-password/RecoverPassword.vue")
				},
				{
					path: "",
					redirect: { name: "login" }
				}
			]
		},
		{
			name: "Admin",
			path: "/admin",
			component: AppLayout,
			children: [
				{
					name: "dashboard",
					path: "dashboard",
					component: () => import("../components/dashboard/Dashboard.vue"),
					default: true,
					meta: {
						requiresAuth: true
					}
				},
				{
					name: "dashboardccn",
					path: "dashboard/:ccn",
					component: () => import("../components/dashboard/Dashboard.vue"),
					props: true,
					meta: {
						requiresAuth: true
					}
				},
				{
					name: "dashboardverif",
					path: "dashboard/:verif",
					component: () => import("../components/dashboard/Dashboard.vue"),
					props: true,
					meta: {
						requiresAuth: true
					}
				},
				{
					name: "dashboardliquid",
					path: "dashboard/:liquidation",
					component: () => import("../components/dashboard/Dashboard.vue"),
					props: true,
					meta: {
						requiresAuth: true
					}
				},
				{
					name: "partenaires",
					path: "partenaires",
					component: EmptyParentComponent,
					children: [
						{
							name: "contacts",
							path: "contacts/:listtype/:idpartenaire?",
							component: () =>
								import(
									"../components/partenaires/DashboardTablePartenaires.vue"
								),
							props: true,
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				{
					name: "publications",
					path: "publications",
					component: EmptyParentComponent,
					children: [
						{
							name: "liste-publication",
							path: "liste/:idnumero?/:edition?",
							component: () => import("../components/publications/liste.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "annonces",
							path: "annonces/:idnumero?",
							component: () =>
								import("../components/publications/annonces.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "devis",
							path: "devis",
							component: () => import("../components/publications/devis.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "factures",
							path: "factures",
							component: () =>
								import("../components/publications/facturesListe.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "configuration-annonces",
							path: "configurations",
							component: () =>
								import("../components/publications/configuration.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "impayes",
							path: "impayes",
							component: () => import("../components/publications/impayes.vue"),
							props: false,
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				{
					name: "publications_web",
					path: "publications-web",
					component: EmptyParentComponent,
					children: [
						{
							name: "liste-publication-web",
							path: "liste/:idnumero?/:edition?",
							component: () => import("../components/publications_web/liste.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "annonces-web",
							path: "annonces/:idnumero?",
							component: () =>
								import("../components/publications_web/annonces.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "devis-web",
							path: "devis",
							component: () => import("../components/publications_web/devis.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "factures-web",
							path: "factures",
							component: () =>
								import("../components/publications_web/facturesListe.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "configuration-annonces-web",
							path: "configurations",
							component: () =>
								import("../components/publications_web/configuration.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "impayes-web",
							path: "impayes",
							component: () => import("../components/publications_web/impayes.vue"),
							props: false,
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				{
					name: "campaigns",
					path: "campaigns",
					component: EmptyParentComponent,
					children: [
						{
							name: "campaign-unpf",
							path: "unpf",
							component: () =>
								import("../components/campaigns/CampaignUnpf.vue"),
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "campaign-spef",
							path: "spef",
							component: () =>
								import("../components/campaigns/CampaignSpef.vue"),
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "campaign-norelance",
							path: "ne-pas-relancer",
							component: () =>
								import("../components/campaigns/DashboardRemoveCampaign.vue"),
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				{
					name: "adherents",
					path: "adherents",
					component: EmptyParentComponent,
					children: [
						{
							name: "adherents-unpf",
							path: "unpf",
							component: () =>
								import("../components/dashboard/adherents/DashboardUnpf.vue"),
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "adherents-spef",
							path: "spef",
							component: () =>
								import("../components/dashboard/adherents/DashboardSpef.vue"),
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "adherents-opef",
							path: "opef",
							component: () =>
								import("../components/dashboard/adherents/DashboardOpef.vue"),
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "adherents-autres",
							path: "adherents/:nomadhesion",
							component: () =>
								import(
									"../components/dashboard/autresadherents/DashboardTableAutresAdherents.vue"
								),
							props: true,
							meta: {
								requiresAuth: true
							}
						}
					]
				},
				{
					name: "communication",
					path: "communication",
					component: EmptyParentComponent,
					children: [
						{
							name: "mapa",
							path: "mapa",
							component: () => import("../components/MAPA/DashboardMapa.vue"),
							default: false,
							meta: {
								requiresAuth: true,
								requiresAdmin: true
							}
						}
					]
				},
				{
					name: "prelevements",
					path: "prelevements",
					component: () =>
						import("../components/prelevements/DashboardPrelevements.vue"),
					default: false,
					meta: {
						requiresAuth: true
					}
				},
				{
					name: "Journal",
					path: "journal",
					component: EmptyParentComponent,
					children: [
						{
							name: "dashboard-journal",
							path: ":listtype/:identite?",
							component: () =>
								import("../components/journal/DashboardJournal.vue"),
							default: false,
							props: true,
							meta: {
								requiresAuth: true,
								requiresAdmin: true
							}
						},
						{
							name: "historique-journal",
							path: "historique",
							component: () =>
								import("../components/journal/DashboardHistoriqueJournal.vue"),
							default: false,
							meta: {
								requiresAuth: true,
								requiresAdmin: true
							}
						}
					]
				},
				{
					name: "retours",
					path: "retours",
					component: () => import("../components/retours/DashboardRetours.vue"),
					default: false,
					meta: {
						requiresAuth: true
					}
				},
				{
					name: "afpf",
					path: "afpf",
					component: EmptyParentComponent,
					children: [
						{
							name: "liste-formations",
							path: "formations/:idformation?",
							component: () => import("../components/afpf/liste_formations.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "entreprises-afpf",
							path: "entreprises/:identreprise?",
							component: () => import("../components/afpf/entreprises.vue"),
							props: true,
							meta: {
								requiresAuth: true
							}
						},
						{
							name: "settings-afpf",
							path: "parametres",
							component: () => import("../components/afpf/settings.vue"),
							meta: {
								requiresAuth: true
							}
						}]
				},
				{
					name: "export",
					path: "export",
					component: EmptyParentComponent,
					children: [
						{
							name: "adherents-export",
							path: "adherents",
							component: () =>
								import("../components/export/DashboardExportAdherents.vue"),
							default: false,
							meta: {
								requiresAuth: true,
								requiresAdmin: false
							}
						},
						{
							name: "emails-export",
							path: "emails",
							component: () =>
								import("../components/export/DashboardExportEmails.vue"),
							default: false,
							meta: {
								requiresAuth: true,
								requiresAdmin: false
							}
						},
						{
							name: "acota-export",
							path: "acota",
							component: () =>
								import("../components/export/DashboardExportAcota.vue"),
							default: false,
							meta: {
								requiresAuth: true,
								requiresAdmin: false
							}
						}
					]
				},
				{
					name: "other-adhesions",
					path: "adhesions-tierces",
					component: EmptyParentComponent,
					children: [
						{
							name: "gestion-other-adhesions",
							path: "adhesions",
							component: () =>
								import("../components/adhesionsTierces/AdhesionsTierces.vue"),
							default: false,
							props: false,
							meta: {
								requiresAuth: true,
								requiresAdmin: true
							}
						},
						{
							name: "adherents-other-adhesions",
							path: "adherents",
							component: () =>
								import(
									"../components/adhesionsTierces/TableAdherentsTierces.vue"
								),
							default: false,
							props: false,
							meta: {
								requiresAuth: true,
								requiresAdmin: true
							}
						}
					]
				},

				{
					name: "users",
					path: "utilisateurs",
					component: () => import("../components/users/Users.vue"),
					default: false,
					meta: {
						requiresAuth: true,
						requiresAdmin: true
					}
				},
				{
					name: "users-stats",
					path: "statistiques-utilisateurs",
					component: () => import("../components/users/UsersStats.vue"),
					default: false,
					meta: {
						requiresAuth: true,
						requiresAdmin: true
					}
				},
				{
					name: "upload",
					path: "uploaddoc",
					component: () => import("../components/uploads/UploadDoc.vue"),
					default: false,
					meta: {
						requiresAuth: true,
						requiresAdmin: true
					}
				}
			]
		}
	]
});
